import sitecfg from '@/sitecfg.js'

const state = sitecfg
export default {
  state,
};
